import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { ms: { type: Number, default: 1500 } }

  guard(event) {
    const el = event.submitter || this.element
    if (el.dataset.disabled === "true") {
      event.preventDefault()
      return
    }

    el.dataset.disabled = "true"
    el.classList.add("disabled")
    if ("disabled" in el) el.disabled = true

    window.setTimeout(() => {
      el.dataset.disabled = "false"
      el.classList.remove("disabled")
      if ("disabled" in el) el.disabled = false
    }, this.msValue)
  }
}
